import React, {useEffect, useState} from "react";
import {notification, Radio} from "antd";
import {Col, Form, Row} from "react-bootstrap";
import TextInput from "../../../../components/common/input-field/TextInput";
import {checkEmptySpaces, maxLength, Required} from "../../../../utils/patterns";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router";
import ThemeButton from "../../../../components/common/theme-button/ThemeButton";
import {RoundedCheck} from "../../../../../assets/icons/defaultIcons";
import DescriptionField from "../../../../components/common/description-field/DescriptionField";
import {QuestionService} from "../../../../services/questions-api.service";
import {JournalService} from "../../../../services/journals-api.service";
import {useJournal} from "../../../../providers/JournalContext";
import JournalModalSkeleton from "../../../skeletons/journals/JournalModalSkeleton";

export default function JournalsModal({close}) {
    const [value1, setValue1] = useState("free-flow");
    const [loader, setLoader] = useState(true);
    const [questionReFrame, setQuestionReFrame] = useState({});
    const [questionFreeFlow, setQuestionFreeFlow] = useState({});
    const [questionDevotional, setQuestionDevotional] = useState({});
    const [questionType, setQuestionType] = useState("free-flow");
    const [allJournals, setAllJournals] = useState(null);
    const [selectedItem, setSelectedItem] = useState("All");
    const [listing, setListing] = useState(false);
    const navigate = useNavigate();
    const { validateJournalPass, setValidateJournalPass, firstTimePassword } = useJournal();

    const {
        handleSubmit,
        formState: { errors },
        control,
        reset,
        getValues,
    } = useForm({ mode: "onChange" });

    async function GetJournals(type) {
        setLoader(true);
        const response = await JournalService.getJournal(type);
        if (response?.data?.data?.status) {
            setAllJournals(response?.data?.data?.data?.result);
            setLoader(false);
        }
    }

    async function GetQuestions(payload, setFunction) {
        setLoader(true);
        const response = await QuestionService.getQuestion(payload);
        if (response?.data?.status) {
            setFunction(response?.data?.data?.data[0]);
        }
        setLoader(false);
    }

    useEffect(() => {
        GetQuestions({ type: "re-frame" }, setQuestionReFrame);
        GetQuestions({ type: "free-flow" }, setQuestionFreeFlow);
        GetQuestions({ type: "devotional" }, setQuestionDevotional);
    }, []);

    useEffect(() => {
        GetJournals(selectedItem !== "All" ? selectedItem : "");
    }, [selectedItem, listing]);

    const selectedQuestions =
        questionType === "re-frame" ? questionReFrame :
            questionType === "free-flow" ? questionFreeFlow :
                questionType === "devotional" ? questionDevotional :
                    null;

    const onSubmit = async (data) => {
        const contentArray = [];
        setLoader(true);

        if (selectedQuestions?.multiQuestions) {
            selectedQuestions.multiQuestions.forEach((question, index) => {
                const questionValue = getValues(`question${index}`);
                if (questionValue) {
                    contentArray.push({ label: question, text: questionValue });
                }
            });
        }

        const payload = {
            questionId: selectedQuestions?._id,
            content: contentArray,
            type: questionType,
        };

        const response = await JournalService.createJournal(payload);

        if (response?.data?.data?.status) {
            notification.success({
                message: "Success",
                description: response?.data?.data?.message,
                placement: "topRight",
                icon: <RoundedCheck />,
                duration: 2,
            });
            reset();
            close(false);
        }
        setLoader(false);
    };

    const options = [
        { label: "Free Flow", value: "free-flow" },
        { label: "Re-Frame", value: "re-frame" },
        { label: "Devotional", value: "devotional" },
    ];

    const onChange1 = ({ target: { value } }) => {
        setQuestionType(value);
        setValue1(value);
    };

    if (loader) {
        return <JournalModalSkeleton />;
    }

    return (
        <div className={"journals journals-modal"} style={{height:'80vh'}}>
            {!loader && (
                <Row>
                    <Col md={12} lg={12} xl={12}>
                        <div className={"type"}>
                            <h4>Select Type</h4>
                            <Radio.Group options={options} onChange={onChange1} value={value1} />
                        </div>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <div className={"create-events"}>
                                <Row>
                                    {selectedQuestions?.multiQuestions?.map((item, index) => (
                                        <Col md={12} key={index}>
                                            <div className={"dfields"}>
                                                <Controller
                                                    name={`question${index}`}
                                                    defaultValue={""}
                                                    control={control}
                                                    rules={{
                                                        required: Required,
                                                        maxLength: maxLength(10000),
                                                        validate: checkEmptySpaces,
                                                    }}
                                                    render={({ field: { name, ...field } }) => (
                                                        value1 === "free-flow" || value1 === "devotional" ? (
                                                            <DescriptionField
                                                                label={item}
                                                                placeholder={"Write your text here"}
                                                                type={"text"}
                                                                defaultValue={field.value}
                                                                field={field}
                                                                errors={errors[`question${index}`]}
                                                                className={"required"}
                                                                autoSize={{ minRows: 18, maxRows: 18 }}
                                                            />
                                                        ) : (
                                                            <TextInput
                                                                placeholder={"Write your text here"}
                                                                label={item}
                                                                type={"text"}
                                                                field={field}
                                                                errors={errors[`question${index}`]}
                                                                className={"required"}
                                                            />
                                                        )
                                                    )}
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <div className={"d-flex flex-column"}>
                                            <ThemeButton type={"Submit"} text={"Submit"} className={"btn-light-lg mt-3"} loader={loader} />
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </Col>
                </Row>
            )}
        </div>
    );
}
